import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index.js";
import Landing from "../views/Landing";
import Block from "../views/Block.vue";
import Management from "../views/Management.vue";
import Forms from "../views/Form/Forms";
import Login from "../components/Login.vue";
import Users from "../views/Users";
import Add from "@/components/Form/Add";
import Edit from "@/components/Form/Edit";
import FormsResult from "@/views/Form/FormsResult";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Landing",
    component: Landing,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/blocks",
    name: "Block",
    component: Block,
    meta: {
      requiresAuth: true
    },
    props: {
      landing_id: {
        type: String,
        required: true
      }
    }
  },
  {
    path: "/management",
    name: "Management",
    component: Management,
    meta: {
      requiresAuth: true
    },
    props: {
      landing_id: {
        type: String,
        required: true
      },
      block_index: {
        type: Number,
        required: false
      }
    }
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/forms",
    name: "Forms",
    component: Forms,
    meta: {
      requiresAuth: true
    },
    props: {
      landing_id: {
        type: String,
        required: true
      }
    }
  },
  {
    path: "/forms/add",
    name: "FormAdd",
    component: Add,
    meta: {
      requiresAuth: true
    },
    props: {
      landing_id: {
        type: String,
        required: true
      }
    }
  },
  {
    path: "/forms/edit",
    name: "FormAdd",
    component: Edit,
    meta: {
      requiresAuth: true
    },
    props: {
      landing_id: {
        type: String,
        required: true
      },
      form_id: {
        type: String,
        required: true
      }
    }
  },
  {
    path: "/forms/results",
    name: "FormsResult",
    component: FormsResult,
    meta: {
      requiresAuth: true
    },
    props: {
      landing_id: {
        type: String,
        required: true
      },
      form_id: {
        type: String,
        required: true
      }
    }
  },
  {
    path: "/login",
    name: "login",
    component: Login
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});

export default router;
